import React, { useEffect, createContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  Outlet,
  useNavigate,
  useSearchParams,
} from "react-router-dom/dist";
import { AuthUserDataAction } from "../actions/userAuthActions";
import { UI_MODE } from "../../../general/constants/uiModeConstans";
import AgoraRTC from "agora-rtc-sdk-ng";
import LottieLoadingLine from "../../../general/components/lottie/lineLoading/LottieLoadingLine";
import { LogoFullColor } from "../../../general/assets/assets";

// export const UserTypeContext = createContext();
export default function GenerateAuth() {
  const navigate = useNavigate();
  const store = useSelector((state) => state.authmodul_user_data);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const dataBase64 = searchParams.get("data");
  const checkBrowserSupport = AgoraRTC.checkSystemRequirements();
  useEffect(() => {
    if (dataBase64 != null) {
      dispatch(AuthUserDataAction(dataBase64));
    } else {
      setLoading(false);
    }
  }, [dataBase64]);

  useEffect(() => {
    if (store.success) {
      setLoading(false);
      console.log("Validasi success", store.data, dataBase64);
    }
    if (store.error) {
      setLoading(false);

      console.log("Here error store");
    }
  }, [store]);
  return (
    <div className="bg-black min-h-screen">
      {checkBrowserSupport == false && <Navigate to="/415" />}
      {loading && (
        <div className="absolute top-0 w-full left-0 h-2 overflow-hidden bg-gray-900">
          <LottieLoadingLine />
        </div>
      )}

      {loading == false && (
        <>
          {store.data?.token != null &&
          typeof store.data?.token == "string" &&
          store?.data?.sessionInfo?.expired == false ? (
            <Navigate
              to={
                store?.data?.sessionInfo?.isOpen == true
                  ? "/Live/" +
                    UI_MODE(store.data.sessionInfo?.uiMode) +
                    "/" +
                    store.data.session
                  : "/waiting-room/" + store.data.session
              }
            />
          ) : (
            <Navigate to="/404" />
            // "Gagal" + store.data.token
          )}
        </>
      )}

      <div className="flex items-center justify-center h-screen">
        <LogoFullColor className="h-10 lg:h-20" />
      </div>
      {dataBase64 == null}
    </div>
  );
}
